export const MATCH_ANY_STRING_REGEX = /^\S{1,40}$/;
export const PROMO_CODE = 'PromoCode';
